import type { RehypeTruncateOptions } from './rehype-truncate';
import remarkGfm from 'remark-gfm';
import rehypeMinifyWhitespace from 'rehype-minify-whitespace';
import rehypeParse from 'rehype-parse';
import rehypeRemark from 'rehype-remark';
import rehypeStringify from 'rehype-stringify';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import remarkStringify from 'remark-stringify';
import { unified } from 'unified';
import rehypeTruncate from './rehype-truncate';
import remarkCondense from './remark-condense';
import rehypeNormalizeCodeBlock from './rehype-normalize-code-block';
import rehypeExternalLinks from './rehype-external-links';

export type MarkdownToHtmlOptions = {
  truncate?: RehypeTruncateOptions;
  condensed?: boolean;
  forceExternalLinks?: boolean;
};

export async function markdownToHtml(
  markdown: string,
  options?: MarkdownToHtmlOptions
): Promise<string> {
  const processor = unified().use(remarkParse).use(remarkGfm);

  if (options?.condensed) {
    processor.use(remarkCondense);
  }

  processor.use(remarkRehype, { allowDangerousHtml: true });

  if (options?.truncate) {
    processor.use(rehypeTruncate, options.truncate);
  }

  if (options?.forceExternalLinks) {
    processor.use(rehypeExternalLinks);
  }

  processor
    .use(rehypeMinifyWhitespace, { newlines: true })
    .use(rehypeNormalizeCodeBlock)
    .use(rehypeStringify);

  const file = await processor.process(markdown);

  return String(file);
}

export function markdownToHtmlSync(
  markdown: string,
  options?: MarkdownToHtmlOptions
): string {
  const processor = unified().use(remarkParse).use(remarkGfm);

  if (options?.condensed) {
    processor.use(remarkCondense);
  }

  processor.use(remarkRehype);

  if (options?.truncate) {
    processor.use(rehypeTruncate, options.truncate);
  }

  if (options?.forceExternalLinks) {
    processor.use(rehypeExternalLinks);
  }

  processor
    .use(rehypeMinifyWhitespace, { newlines: true })
    .use(rehypeNormalizeCodeBlock)
    .use(rehypeStringify);

  const file = processor.processSync(markdown);

  return String(file);
}

export async function htmlToMarkdown(html: string): Promise<string> {
  const file = await unified()
    .use(rehypeParse, { fragment: true })
    .use(rehypeRemark)
    .use(remarkGfm)
    .use(remarkStringify, {
      bullet: '-',
      fences: true,
      rule: '_',
    })
    .process(html);

  return String(file);
}
